<template>
  <span>
    <Mentionable :keys="['@']" :items="lc_get()" offset="10">
      <v-textarea
        dense
        outlined
        placeholder="Comment"
        :rules="[myrules.required]"
        @input="(value) => onChange(value)"
      />
      <template #item-@="{ item }">
        <div class="issue">
          <span class="number">
            @{{ item.value }}
          </span>
        </div>
      </template>

    </Mentionable>
    
    <!-- <mentionable-textarea :modeIdentifiers="modeIdentifiers" /> -->
  </span>
</template>

<script>
import { Mentionable } from "vue-mention";
export default {
  props: ["comments", "onChange"],
  components: {
    Mentionable,
  },
  methods: {
    lc_get() {
      return this.userConnects.map((userConnect) => ({
        value: userConnect.username,
        label: userConnect.username,
      }));
    },
  },
};
</script>

<style>
.issue{
    padding:5px;
    cursor: pointer;
}
.issue:hover{
    background: #4e02fc;
    color:#fff;
}
</style>